import getConfig from 'next/config';

const { CORE_URL } = getConfig().publicRuntimeConfig;

export const healthFormRedirectHandler = (data) => {
  const members = {
    mySelf: {
      age: data.age,
      gender: data.gender,
    },
  };

  const queryParams = new URLSearchParams({
    gender: data.gender,
    age: data.age,
    phoneNumber: data.phoneNumber,
    category: 'health',
    fullName: data.fullName,
    step: '1',
    selfChecked: 'true',
    members: JSON.stringify(members),
  });
  
  window.location.href = `${CORE_URL}/search?${queryParams.toString()}`;
};
